// store.js
import Vue from 'vue'
import Vuex from 'vuex'
// vuex持久化插件
import createPersistedState from 'vuex-persistedstate'

// 头部分类
// import login from './modules/login'
// import category from './modules/category'
// import login from './modules/login'

const requiredModules = require.context('./modules', false, /\.js$/)
const modules = {}
requiredModules.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\.js)/g, '')
  modules[moduleName] =
    requiredModules(fileName).default || requiredModules(fileName)
})
Vue.use(Vuex)
export default new Vuex.Store({
  modules,
  plugins: [createPersistedState({
    key: 'tmcpc',
    storage: window.localStorage // 选择localStorage 进行存储
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js